import React, {Component} from 'react';
import LandingHeader from './../Landing/LandingHeader.js'
import Footer from '../Footer'
import DeliveryAddressMain from './DeliveryAddressMain.js'

class DeliveryAddress extends Component {
  render() {
    return (
      <div className="body">
        <LandingHeader/>
        <DeliveryAddressMain/>
        <Footer/>
      </div>
    );
  }
}

export default DeliveryAddress;


// WEBPACK FOOTER //
// ./src/components/DeliveryAddress/DeliveryAddress.js